import { IblImportResult } from './ibl-import-result.enum';
import { MissingResourceType } from './missing-resouce-type.enum';

export interface IIblImportResponseDto {
  importResult: IblImportResult;
  warnings: IIblImportWarning[];
  errors: IIblImportError[];
}

export interface IIblImportIssue {
  kks: string;
  vgbm: string;
  vgbmDescription?: string;
}

export interface IIblImportError extends IIblImportIssue {
  type: IblImportErrorType;
  resourceType?: MissingResourceType;
  message?: string;
}

export interface IIblImportWarning extends IIblImportIssue {
  type: IblImportWarningType;
  invalidValue?: string;
  invalidUnit?: string;
  message?: string;
}

export enum IblImportErrorType {
  CONFLICT = 'conflict',
  INTERNAL_ERROR = 'internal_error',
  MISSING_RESOURCE = 'MissingResourceError',
}

export enum IblImportWarningType {
  INVALID_KKS = 'invalid_kks',
  INVALID_VALUE = 'invalid_value',
  INVALID_UNIT = 'invalid_unit',
  UNKNOWN_WARNING = 'unknown_warning',
}
